import React from "react";
import "./styles.scss";

const PortfolioScreening = () => {
    return (
        <div className="portfolio-screening-main">
            <iframe
                src="/portfolio-screening.html"
                title="Portfolio Screening"
                className="portfolio-screening-frame"
            />
        </div>
    );
};

export default PortfolioScreening;
